import { Resource } from "react-admin";
import { DefaultList } from "../misc/DefaultList";

export const serviceEntriesResource = (
  <Resource
    key="serviceEntries"
    name="serviceEntries"
    list={DefaultList}
    options={{
      label: "Leistungen",
      noEntriesText: "Noch keine Leistungen vorhanden.",
      noMatchingEntriesText: "Keine passenden Leistungen gefunden.",
    }}
  />
);
